import React from "react";
import { observer } from "mobx-react";
import { UserAttachmentEditionCreateStore } from "../../store";
import { UserAttachmentEditionCreateForm } from "./UserAttachmentEditionCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type UserAttachmentEditionCreateProps = {
  userAttachmentEditionCreateStore: UserAttachmentEditionCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserAttachmentEditionCreate: React.FC<UserAttachmentEditionCreateProps> =
  observer(
    ({
      userAttachmentEditionCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={userAttachmentEditionCreateStore.isSaving} />
          <UserAttachmentEditionCreateForm
            userAttachmentEditionCreateStore={userAttachmentEditionCreateStore}
            nameError={userAttachmentEditionCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              userAttachmentEditionCreateStore.setNameValue(value);
            }}
            name={userAttachmentEditionCreateStore.entityValues.name}
            fileOnRestoreFile={(id: string) =>
              userAttachmentEditionCreateStore.fileRestoreFile(id)
            }
            fileOnLoadFile={(file: any) =>
              userAttachmentEditionCreateStore.fileUploadFile(file)
            }
            fileOnCommitFile={(changes) =>
              userAttachmentEditionCreateStore.fileCommitFile(changes)
            }
            fileFiles={
              userAttachmentEditionCreateStore.entityValues.__file_files
            }
            fileError={userAttachmentEditionCreateStore.errors.file?.message}
            notesError={userAttachmentEditionCreateStore.errors.notes?.message}
            onNotesChange={(value: string) => {
              userAttachmentEditionCreateStore.setNotesValue(value);
            }}
            notes={userAttachmentEditionCreateStore.entityValues.notes}
            dummyCRUDRestoredObservable={
              userAttachmentEditionCreateStore.dummyCRUDRestoredObservable
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={userAttachmentEditionCreateStore.isProcessing}
            onSave={() =>
              userAttachmentEditionCreateStore.saveNewUserAttachmentEdition()
            }
            onCancel={() =>
              userAttachmentEditionCreateStore.cancelNewUserAttachmentEdition()
            }
          />
          <ErrorDialog
            open={userAttachmentEditionCreateStore.errorDialogOpened}
            title={userAttachmentEditionCreateStore.errorTitle}
            description={userAttachmentEditionCreateStore.errorDescription}
            onClose={() => userAttachmentEditionCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
